import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31309973"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card bg-light booking-section" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = {
  class: "row",
  style: {"margin-left":"-12px","margin-right":"-12px"}
}
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Key Pickup/Access", -1))
const _hoisted_8 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_9 = {
  key: 0,
  class: "form-group"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Branch", -1))
const _hoisted_11 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Title", -1))
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Key Pickup Address - Line 1", -1))
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Line 2", -1))
const _hoisted_17 = { class: "col-md-1" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Town", -1))
const _hoisted_19 = {
  class: "col-md-1",
  style: {"min-width":"150px"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Postcode", -1))
const _hoisted_21 = {
  class: "col-md-1",
  style: {"min-width":"150px"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Phone", -1))
const _hoisted_23 = { class: "col-md-1" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Access confirmed", -1))
const _hoisted_25 = { class: "height-43" }
const _hoisted_26 = {
  class: "row",
  style: {"margin-left":"-12px","margin-right":"-12px","margin-top":"12px"}
}
const _hoisted_27 = { class: "col" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Return/Release Keys to", -1))
const _hoisted_31 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_32 = {
  key: 0,
  class: "form-group"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Branch", -1))
const _hoisted_34 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Title", -1))
const _hoisted_36 = { class: "col-md-3" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Key Release To - Line 1", -1))
const _hoisted_38 = { class: "col-md-3" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Line 2", -1))
const _hoisted_40 = { class: "col-md-1" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Town", -1))
const _hoisted_42 = {
  class: "col-md-1",
  style: {"min-width":"150px"}
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Postcode", -1))
const _hoisted_44 = {
  class: "col-md-1",
  style: {"min-width":"150px"}
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Phone", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, null, -1))
const _hoisted_47 = {
  class: "row",
  style: {"margin-left":"-12px","margin-right":"-12px","margin-top":"12px"}
}
const _hoisted_48 = { class: "col-md-6" }
const _hoisted_49 = {
  key: 0,
  class: "col-form-label"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo-alt" }, null, -1))
const _hoisted_51 = ["onUpdate:modelValue"]
const _hoisted_52 = {
  key: 0,
  class: "col-form-label"
}
const _hoisted_53 = ["onUpdate:modelValue"]
const _hoisted_54 = { class: "col-md-3" }
const _hoisted_55 = {
  key: 0,
  class: "col-form-label"
}
const _hoisted_56 = { style: {"display":"flex"} }
const _hoisted_57 = ["onUpdate:modelValue"]
const _hoisted_58 = {
  key: 0,
  class: "fas fa-info-circle text-right ml-2 mt-3 text-danger",
  title: "International number, will not send SMS"
}
const _hoisted_59 = { class: "col-md-1 mt-2" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus" }, null, -1))
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = ["onClick"]
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-md-11 text-right" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_69 = { class: "col-md-3" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Access notes seen by PI ", -1))
const _hoisted_71 = { class: "col-md-3" }
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "col-md-6" }
const _hoisted_74 = { class: "form-group" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Is Tenant Attending?", -1))
const _hoisted_76 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Releasing keys", -1))
const _hoisted_78 = { class: "row" }
const _hoisted_79 = { class: "col-md-6" }
const _hoisted_80 = { class: "form-group" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Do not contact", -1))
const _hoisted_82 = { class: "col-md-6" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Access confirmation (PDF/Word/JPEG Only):", -1))
const _hoisted_84 = { class: "row" }
const _hoisted_85 = { class: "col-md-6" }
const _hoisted_86 = { class: "col-md-6" }

import { computed, ref, watch, nextTick,inject } from 'vue';
import { useStore } from 'vuex';
import { Customer, Address, Tenant, Policies, Booking } from "@/models";
import AccessnotesDialog from "@/components/modals/AccessnotesDialog.vue";
import AccessIssueNotesDialog from "@/components/modals/AccessIssueNotesDialog.vue";
import { DxSwitch } from 'devextreme-vue/switch';
import { useRoute } from 'vue-router';

import Documents from "@/components/document/Documents.vue";
import TriStateToggle from "@/components/TriStateToggle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Access',
  emits: ['showaccessattachementdocument'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

// Getters
const store = useStore();
const booking = computed((): Booking => store.getters['diary/booking']);
const jobtype = computed(() => store.getters['diary/jobtype']);
const _keypickup = computed(() => store.getters['diary/keypickup']);
const customer = computed(() => store.getters['diary/customer']);
const managedtype = computed(() => store.getters['diary/managedtype']);
const _keypickupbranchname = computed(() => store.getters['diary/keypickupbranchname']);
const _confirmaccess = computed(() => store.getters['diary/confirmaccess']);
const _accessissues = computed(() => store.getters['diary/accessissues']);
const _releasekeystobranchname = computed(() => store.getters['diary/releasekeystobranchname']);
const _releasekeysto = computed(() => store.getters['diary/releasekeysto']);
const tenantsarray = computed(() => store.getters['diary/tenantsarray']);
const keypickupfromaddress = computed(() => store.getters['diary/keypickupfromaddress']);
const keyreleasetoaddress = computed(() => store.getters['diary/keyreleasetoaddress']);
const _keystobereleased = computed(() => store.getters['diary/keystobereleased']);
const _tenantattending = computed(() => store.getters['diary/tenantattending']);
const _donotcontacttt = computed(() => store.getters['diary/donotcontacttt']);
const selectedCustomername = computed(() => store.getters['diary/selectedCustomername']);
const isQCuser = computed(() => store.getters['auth/isQCUser']);
// Mutations
const setKeypickup = (keypickup: string) => store.commit('diary/setKeypickup', keypickup);
const setKeypickupfromaddress = (address: Address) => store.commit('diary/setKeypickupfromaddress', address);
const setKeyreleasetoaddress = (address: Address) => store.commit('diary/setKeyreleasetoaddress', address);
const setReleasekeysto = (releasekeysto: string) => store.commit('diary/setReleasekeysto', releasekeysto);
const setKeystobereleased = (releasekeysto: string) => store.commit('diary/setKeystobereleased', releasekeysto);
const addStateTenant = (tenant: Tenant) => store.commit('diary/addTenant', tenant);
const removeTenant = (tenant: Tenant) => store.commit('diary/removeTenant', tenant);
const setKeypickupfromaddressDeep = (payload: { path: string; data: string; }) => store.commit('diary/setKeypickupfromaddressDeep', payload);
const setKeyreleasetoaddressDeep = (payload: { path: string; data: string; }) => store.commit('diary/setKeyreleasetoaddressDeep', payload);
const setStateTenantattending = (value: string) => store.commit('diary/setTenantattending', value);
const setDonotcontacttt = (value: string) => store.commit('diary/setDonotcontacttt', value);
const addUnsavedChange = (element: string) => store.commit('diary/addUnsavedChange', element);
const setBookingDeep = (payload: { path: string; data: any }) => store.dispatch('diary/setBookingDeep', payload);
const route = useRoute();
const actProperty: any = inject('actProperty');

// Actions
const getCustomers = async (payload?: {
  starts_with?: string;
  company_name?: string;
  branch_name?: string;
  managedtype?: string;
}): Promise<Customer[]> => {
  return await store.dispatch('diary/getCustomers', payload);
};
const getBranchNameOptionsWithManagedtype = async (payload?: {
  company_name?: string;
  managedtype?: string;
}): Promise<any> => {
  return await store.dispatch('diary/getBranchNameOptionsWithManagedtype', payload);
};

let keypickupOptions: string[] = [
  "From Agency",
  "Meet Tenant",
  "Via Concierge",
  "Via Landlord",
  "TBC",
  "Misc",
];
const keypickupbranchNameOptions = ref([]);
const keyreleasebranchNameOptions = ref([]);
const releasekeysOptions: string[] = ["Yes", "No", "TBC"];
const keypickupbranchnamesearchfilter = ref('');
const keyreleasebranchnamesearchfilter = ref('');
const accessissuesref = ref(null);

const accessnotesModal = ref(null);
const accessissuesnotesModal = ref(null);
const dynamicRefs = ref({});

const expanded = ref(false);

const keypickup = computed({
  get: () => _keypickup.value,
  set: (val: string) => {
    setKeypickup(val);
    if (keypickup.value != "From Agency")
      setKeypickupfromaddress(new Address());
  }
});

const changeKeypickupbranchnameoptions = async () => {
  if (keypickup.value === "From Agency") {
    if (customer.value && customer.value.companyName) {
      keypickupbranchNameOptions.value = await getBranchNameOptionsWithManagedtype({
        company_name: customer.value.companyName,
        managedtype: managedtype.value,
      });
    } else if (selectedCustomername.value) {
      keypickupbranchNameOptions.value = await getBranchNameOptionsWithManagedtype({
        company_name: selectedCustomername.value,
        managedtype: managedtype.value,
      });
    } else {
      keypickupbranchNameOptions.value = [];
      keypickupbranchname.value = "";
    }
  }
};

const changeKeyreleasebranchnameoptions = async () => {
  if (releasekeysto.value === "To Agency") {
    if (customer.value && customer.value.companyName) {
      keyreleasebranchNameOptions.value = await getBranchNameOptionsWithManagedtype({
        company_name: customer.value.companyName,
        managedtype: managedtype.value,
      });
    } else if (selectedCustomername.value) {
      keyreleasebranchNameOptions.value = await getBranchNameOptionsWithManagedtype({
        company_name: selectedCustomername.value,
        managedtype: managedtype.value,
      });
    } else {
      keyreleasebranchNameOptions.value = [];
      releasekeystobranchname.value = "";
    }
  }
};

const keypickupbranchname = computed({
  get: () => _keypickupbranchname.value,
  set: (name) => {
    store.commit('diary/setKeypickupbranchname', name);
    if(!name){
      setKeypickupfromaddress(new Address());
      keypickupfromaddressPhone.value = '';
    }
    if (releasekeysto.value === "To Agency" && !releasekeystobranchname.value) {
      store.commit('diary/setReleasekeystobranchname', name);
      releasekeystobranchname.value = name;
    }
  }
});

const onTagKeypickupBranchName = (val) => {
  keypickupbranchname.value = val;
  setKeypickupfromaddress(new Address());
  keypickupfromaddressPhone.value = '';
};

const onKeypickupSelected = async (val) => {
  if (val === "From Agency" && !releasekeysto.value) {
    keypickupbranchname.value = customer.value.branchName;
    let { address, policies } = await getBranchAddress(customer.value.branchName);
    setKeypickupfromaddress(new Address(address));
    keypickupfromaddressPhone.value = policies.phone;
    if (!customer.value.policies.accessconfirm) {
      confirmaccess.value = true;
    }
  } 
  if (val !== "From Agency"){
    keypickupbranchname.value = '';
    setKeypickupfromaddress(new Address());
    keypickupfromaddressPhone.value = '';
  }
};


const onKeypickupbranchSelected = async (branchName) => {
  let { address, policies } = await getBranchAddress(branchName);
  setKeypickupfromaddress(new Address(address));
  keypickupfromaddressPhone.value = policies.phone;
  if (releasekeysto.value === "To Agency" && keyreleasetoaddress.value.isempty) {
    setKeyreleasetoaddress(new Address(address));
  }
};

const onKeyreleasebranchSelected = async (branchName) => {
  if (branchName) {
    let { address, policies } = await getBranchAddress(branchName);
    setKeyreleasetoaddress(new Address(address));
    keyreleasetoaddressPhone.value = policies.phone;
  }
};

const onTagKeyreleaseBranchName = (val) => {
  releasekeystobranchname.value = val;
  setKeyreleasetoaddress(new Address());
};

const getBranchAddress = async (branchName) => {
  let address = new Address();
  let policies = new Policies();
  if (branchName) {
    const customers = await getCustomers({
      company_name: customer.value.companyName,
      branch_name: branchName,
      managedtype: booking.value.managedtype, // Assuming booking is a reactive reference
    });
    if (customers && customers.length) {
      policies = customers[0].policies;
      address = customers[0].address;
    }
  }
  return { address, policies };
};


const confirmaccess = computed({
  get: () => _confirmaccess.value,
  set: (val) => store.commit('diary/setConfirmaccess', val)
});

const accessissues = computed({
  get: () =>  {
    accessissuesref.value = _accessissues.value
    return _accessissues.value;
  },
  set: (val) => {
    accessissuesref.value = val;
    store.commit('diary/setAccessissues', val)
  }
});


const releasekeystobranchname = computed({
  get: () => _releasekeystobranchname.value,
  set: (name) => store.commit('diary/setReleasekeystobranchname', name)
});

const releasekeystoOptions = ref([
  "To Agency",
  "Meet Tenant",
  "Via Concierge",
  "Via Landlord",
  "TBC",
  "Misc",
]);

const releasekeysto = computed({
  get: () => _releasekeysto.value,
  set: (val) => {
    setReleasekeysto(val);
    if(!val || val !== "To Agency"){
      setKeyreleasetoaddress(new Address());
      keyreleasetoaddressPhone.value = ''; 
    }
  }
});

const keypickupfromaddressLine1 = computed({
  get: () => keypickupfromaddress.value.line1,
  set: (data) => setKeypickupfromaddressDeep({ path: "line1", data })
});
const keypickupfromaddressName = computed({
  get: () => keypickupfromaddress.value.name,
  set: (data) => setKeypickupfromaddressDeep({ path: "name", data })
});
const keypickupfromaddressLine2 = computed({
  get: () => keypickupfromaddress.value.line2,
  set: (data) => setKeypickupfromaddressDeep({ path: "line2", data })
});

const keypickupfromaddressTown = computed({
  get: () => keypickupfromaddress.value.town,
  set: (data) => setKeypickupfromaddressDeep({ path: "town", data })
});


const keypickupfromaddressPostcode = computed({
  get: () => keypickupfromaddress.value.postcode,
  set: (data) => setKeypickupfromaddressDeep({ path: "postcode", data })
});

const keypickupfromaddressPhone = computed({
  get: () => keypickupfromaddress.value.phone,
  set: (data) => setKeypickupfromaddressDeep({ path: "phone", data })
});

// Computed properties for keyreleasetoaddress
const keyreleasetoaddressName = computed({
  get: () => keyreleasetoaddress.value.name,
  set: (data) => setKeyreleasetoaddressDeep({ path: "name", data })
});
const keyreleasetoaddressLine1 = computed({
  get: () => keyreleasetoaddress.value.line1,
  set: (data) => setKeyreleasetoaddressDeep({ path: "line1", data })
});
const keyreleasetoaddressLine2 = computed({
  get: () => keyreleasetoaddress.value.line2,
  set: (data) => setKeyreleasetoaddressDeep({ path: "line2", data })
});

const keyreleasetoaddressTown = computed({
  get: () => keyreleasetoaddress.value.town,
  set: (data) => setKeyreleasetoaddressDeep({ path: "town", data })
});


const keyreleasetoaddressPostcode = computed({
  get: () => keyreleasetoaddress.value.postcode,
  set: (data) => setKeyreleasetoaddressDeep({ path: "postcode", data })
});

const keyreleasetoaddressPhone = computed({
  get: () => keyreleasetoaddress.value.phone,
  set: (data) => setKeyreleasetoaddressDeep({ path: "phone", data })
});

const tenantattending = computed({
  get: () => _tenantattending.value === "unsure" ? "neutral" : _tenantattending.value,
  set: (val) => {
    val = val === "neutral" ? "unsure" : val;
    setStateTenantattending(val); // Assuming setStateTenantattending is defined
  }
});

const setTenantattending = (val: string) => {
  if (val === "neutral") val = "unsure";
  setStateTenantattending(val);
  booking.value.setAccessAfterTenantattendingChange();
}

const donotcontacttt = computed({
  get: () => _donotcontacttt.value,
  set: (val: string) => setDonotcontacttt(val)
});



const addTenant = () => {
  addStateTenant(new Tenant());
}

// https://trello.com/c/VbNBbsIp/760-1-tenant-responses-manual-override-for-tt-replies
const tenansFlag = (flag:string,tenant:Tenant,index: number) => {
  tenant.attending = flag === 'red' ? 'no' : flag === 'green' ? 'yes' : 'unsure';
  setBookingDeep({
    path: `tenants[${index}]`,
    data:tenant
  });

  const othertenantresponse = actProperty.checkOtherTenantsResponse(booking.value,tenant.ttemail, tenant.attending);
  // Case 1
  if(tenant.attending === 'yes') {
    setTenantattending(tenant.attending);
  }
  // case 2
  else if(tenant.attending === 'no' && othertenantresponse) {
    let filteredTenants = booking.value.tenants.filter((tenant) => {
        return !(tenant.ttname.trim() === "" && tenant.ttmobile.trim() === "" && tenant.ttemail.trim() === "");
    });
    setBookingDeep({ path: "tenants", data: filteredTenants });
    setTenantattending(tenant.attending);
  }
  // Case 3
  else if(tenant.attending === 'unsure') {
    const othersareno = actProperty.checkOtherTenantsResponse(booking.value,tenant.ttemail, 'no');
    if(othersareno) {
      setTenantattending('unsure');
    }
  }

  // Case 4 - is covered by default

}

const showAccessattachementDocument = (index: number) => {
  emit("showaccessattachementdocument", index);
}

const keystobereleased = computed({
  get: () => _keystobereleased.value,
  set: (val: string) => setKeystobereleased(val)
});

const showAccessnotesModal = () => {
  const modal = accessnotesModal.value as any;
  modal.init();
  modal.show();
}

const showAccessIssuesnotesModal = () => {
  const modal = accessissuesnotesModal.value as any;
  modal.show();
}

const accessnotePresent = () => {
  let plaintext = '';
  if (booking.value.accessnotes) {
    var tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = booking.value.accessnotes;
    plaintext = tempDivElement.textContent || tempDivElement.innerText || "";
  }
  return (plaintext.trim().length > 0);
}

const dropDownOpened = (ref: string) => {
  nextTick(() => {
    // Get the reference to the dropdown list container
    const multiselect = dynamicRefs.value[ref] as any;
    const dropdownList = multiselect.$el.querySelector('.multiselect__content-wrapper');

    // Get the reference to the selected option element
    const selectedOption = multiselect.$el.querySelector('.multiselect__option--selected');

    // Scroll to the position of the selected element
    if (selectedOption?.offsetTop)
      dropdownList.scrollTop = selectedOption.offsetTop;
  });
}

const accessissuesrowCount = computed(() => {
  if (!accessissuesref.value) return;
  return accessissuesref.value.scrollHeight > accessissuesref.value.clientHeight;
});

const filteredkeypickupbranchNameOptions = computed(() => {
  return keypickupbranchNameOptions.value.filter((b: string) => {
    if (keypickupbranchnamesearchfilter.value)
      return b.toLowerCase().startsWith(keypickupbranchnamesearchfilter.value.toLowerCase());
    else
      return true;
  })
});


const filteredreleasekeystoOptions = computed(() => {
  return keyreleasebranchNameOptions.value.filter((b: string) => {
    if (keyreleasebranchnamesearchfilter.value)
      return b.toLowerCase().startsWith(keyreleasebranchnamesearchfilter.value.toLowerCase());
    else
      return true;
  })
});


watch(keypickup, async (newValue, oldValue) => {
  await changeKeypickupbranchnameoptions(); // Assuming this is a defined function
  if (newValue === "From Agency") {
    if (!keypickupbranchname.value) { // Assuming keypickupbranchname is a reactive ref
      keypickupbranchname.value = customer.value.branchName;
      let { address, policies } = await getBranchAddress(keypickupbranchname.value); // Assuming getBranchAddress is a defined async function
      setKeypickupfromaddress(new Address(address));
      keypickupfromaddressPhone.value = policies.phone; // Assuming setKeypickupfromaddress is a defined function
    }
  } else {
    // setKeypickupfromaddress(new Address()); // Assuming this is the desired functionality
  }
  // Confirm Access is a false
  if (keypickup.value === "From Agency" && !customer.value.policies.accessconfirm) {
    confirmaccess.value = true;
  }
  if (keypickup.value  === "Via Landlord") {
    if(booking.value.landlordmobilearray.length > 0){
      keypickupfromaddressPhone.value = booking.value.landlordmobilearray[0];
    }
  }
});

watch(releasekeysto, async (newValue, oldValue) => {
  await changeKeyreleasebranchnameoptions(); // Assuming this is a defined function
  if (newValue === "To Agency") {
    if (!releasekeystobranchname.value) { // Assuming releasekeystobranchname is a reactive ref
      releasekeystobranchname.value = customer.value.branchName;
      let { address, policies } = await getBranchAddress(releasekeystobranchname.value);
      setKeyreleasetoaddress(new Address(address));
      keyreleasetoaddressPhone.value = policies.phone;
    }
  }
  //  else {
  //   setKeyreleasetoaddress(new Address()); 
  //   releasekeystobranchname.value = "";
  //   keyreleasetoaddressPhone.value = '';
  // }
  if (newValue === "Via Landlord") {
    if(booking.value.landlordmobilearray.length > 0){
      keyreleasetoaddressPhone.value = booking.value.landlordmobilearray[0];
    }
  }  
});

watch(customer, (newValue, oldValue) => {
  changeKeypickupbranchnameoptions(); // Assuming this is a defined function
  changeKeyreleasebranchnameoptions(); // Assuming this is a defined function
  // Key release required is true
  if (customer.value.policies.keyreleasereq && !keystobereleased.value) {
    keystobereleased.value = 'TBC';
  }
});
const isNewBooking = () => {
  return route.params.id == "new";
}

const isNewBookingOrTenantBlank = (tenant:Tenant) => {
  let flag = false;
  flag =  route.params.id === "new";
  if(flag) return flag;
  if(tenant.ttname.trim() === "" && tenant.ttmobile.trim() === "" && tenant.ttemail.trim() === ""){
    return true;
  }
}

const checkMeetTenant = (option: string) => {
  // The setting is only applicable if Inspection in absence is on for selected customer
  if (!customer.value.policies.inspectioninabs) return false;

  let result = false;
  if (option === 'Meet Tenant') {
    result = true;
  }
  return result;
}

const isInternationalNumber = (mobile) => {
  const regex1 = /^\s*0044\d*\s*$/; // Uk numbers
  if(regex1.test(mobile)) return false;
  const regex2 = /^\s*\+44\d*\s*$/; // Uk numbers
  if(regex2.test(mobile)) return false;

  const regex3 = /^\s*00\d*\s*$/; // International numbers with 00 prefix, followed by one or more digits
  const regex4 = /^\s*\+\d*\s*$/; // International numbers with 00 prefix, followed by one or more digits
  return (regex3.test(mobile) || regex4.test(mobile));
};



return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", {
      class: "card-header booking-section-header",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
    }, "Access"),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", null, [
                _createVNode(_component_singleselect_text, {
                  modelValue: keypickup.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((keypickup).value = $event)),
                  options: _unref(keypickupOptions),
                  "allow-empty": true,
                  taggable: false,
                  onSelect: onKeypickupSelected
                }, _createSlots({
                  option: _withCtx((props) => [
                    _createElementVNode("div", {
                      class: _normalizeClass({
      'text-cross': checkMeetTenant(props.option),
    })
                    }, _toDisplayString(props.option), 3)
                  ]),
                  _: 2
                }, [
                  (keypickup.value)
                    ? {
                        name: "clear",
                        fn: _withCtx(() => [
                          _createElementVNode("i", {
                            onMousedown: _cache[1] || (_cache[1] = _withModifiers(($event: any) => {
                    setKeypickup('');
                  onTagKeypickupBranchName('');
                  }, ["prevent","stop"])),
                            class: "multiselect__clear fa fa-times",
                            "aria-label": "Clear Key Pickup"
                          }, null, 32)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "options"])
              ])
            ]),
            (keypickup.value !== 'Misc')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (keypickup.value === 'From Agency')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("div", null, [
                          _createVNode(_component_singleselect_text, {
                            modelValue: keypickupbranchname.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((keypickupbranchname).value = $event)),
                            options: filteredkeypickupbranchNameOptions.value,
                            "allow-empty": true,
                            disabled: keypickupbranchNameOptions.value.length < 1,
                            taggable: false,
                            onSelect: onKeypickupbranchSelected,
                            ref: el => { dynamicRefs.value['keyPickupBranchDropDown'] = el },
                            onOpen: _cache[5] || (_cache[5] = ($event: any) => (dropDownOpened('keyPickupBranchDropDown'))),
                            onSearchChange: _cache[6] || (_cache[6] = ($event: any) => (keypickupbranchnamesearchfilter.value = $event))
                          }, {
                            clear: _withCtx(() => [
                              (keypickupbranchname.value)
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    onMousedown: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (onTagKeypickupBranchName('')), ["prevent","stop"])),
                                    class: "multiselect__clear fa fa-times",
                                    "aria-label": "Clear Branch Name"
                                  }, null, 32))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "options", "disabled"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (keypickup.value === 'Misc')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    min: "0",
                    class: "form-control height-43",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((keypickupfromaddressName).value = $event)),
                    autocomplete: "keypickupfromaddressName"
                  }, null, 512), [
                    [
                      _vModelText,
                      keypickupfromaddressName.value,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                min: "0",
                class: "form-control height-43",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((keypickupfromaddressLine1).value = $event)),
                autocomplete: "keypickupfromaddressLine1"
              }, null, 512), [
                [
                  _vModelText,
                  keypickupfromaddressLine1.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                min: "0",
                class: "form-control height-43",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((keypickupfromaddressLine2).value = $event)),
                autocomplete: "keypickupfromaddressLine2"
              }, null, 512), [
                [
                  _vModelText,
                  keypickupfromaddressLine2.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            min: "0",
            class: "form-control height-43",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((keypickupfromaddressTown).value = $event)),
            autocomplete: "keypickupfromaddressTown"
          }, null, 512), [
            [
              _vModelText,
              keypickupfromaddressTown.value,
              void 0,
              { lazy: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            min: "0",
            class: "form-control height-43",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((keypickupfromaddressPostcode).value = $event)),
            autocomplete: "keypickupfromaddressPostcode"
          }, null, 512), [
            [
              _vModelText,
              keypickupfromaddressPostcode.value,
              void 0,
              { lazy: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            min: "0",
            class: "form-control height-43",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((keypickupfromaddressPhone).value = $event)),
            autocomplete: "keypickupfromaddressPhone"
          }, null, 512), [
            [
              _vModelText,
              keypickupfromaddressPhone.value,
              void 0,
              { lazy: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_unref(DxSwitch), {
              value: confirmaccess.value,
              onValueChanged: _cache[13] || (_cache[13] = ($event: any) => (confirmaccess.value = $event.value))
            }, null, 8, ["value"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", null, [
                _createVNode(_component_singleselect_text, {
                  modelValue: releasekeysto.value,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((releasekeysto).value = $event)),
                  options: releasekeystoOptions.value,
                  "allow-empty": true,
                  taggable: false
                }, _createSlots({
                  singleLabel: _withCtx((props) => [
                    _createElementVNode("div", {
                      class: _normalizeClass({
      'text-cross': checkMeetTenant(props.option),
    })
                    }, _toDisplayString(props.option), 3)
                  ]),
                  option: _withCtx((props) => [
                    _createElementVNode("div", {
                      class: _normalizeClass({
      'text-cross': checkMeetTenant(props.option),
    })
                    }, _toDisplayString(props.option), 3)
                  ]),
                  _: 2
                }, [
                  (releasekeysto.value)
                    ? {
                        name: "clear",
                        fn: _withCtx(() => [
                          _createElementVNode("i", {
                            onMousedown: _cache[14] || (_cache[14] = _withModifiers(($event: any) => {
      setReleasekeysto('');
    onTagKeyreleaseBranchName('');
    }, ["prevent","stop"])),
                            class: "multiselect__clear fa fa-times",
                            "aria-label": "Clear Key Pickup"
                          }, null, 32)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "options"])
              ])
            ]),
            (releasekeysto.value !== 'Misc')
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  (releasekeysto.value === 'To Agency')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("div", null, [
                          _createVNode(_component_singleselect_text, {
                            modelValue: releasekeystobranchname.value,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((releasekeystobranchname).value = $event)),
                            options: filteredreleasekeystoOptions.value,
                            "allow-empty": true,
                            disabled: keyreleasebranchNameOptions.value.length < 1,
                            taggable: false,
                            onSelect: onKeyreleasebranchSelected,
                            ref: el => { dynamicRefs.value['keyReleaseBranchDropDown'] = el },
                            onOpen: _cache[18] || (_cache[18] = ($event: any) => (dropDownOpened('keyReleaseBranchDropDown'))),
                            onSearchChange: _cache[19] || (_cache[19] = ($event: any) => (keyreleasebranchnamesearchfilter.value = $event))
                          }, {
                            clear: _withCtx(() => [
                              (releasekeystobranchname.value)
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    onMousedown: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (onTagKeyreleaseBranchName('')), ["prevent","stop"])),
                                    class: "multiselect__clear fa fa-times",
                                    "aria-label": "Clear Branch Name"
                                  }, null, 32))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "options", "disabled"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (releasekeysto.value === 'Misc')
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _hoisted_35,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    min: "0",
                    class: "form-control height-43",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((keyreleasetoaddressName).value = $event)),
                    autocomplete: "keyreleasetoaddressName"
                  }, null, 512), [
                    [
                      _vModelText,
                      keyreleasetoaddressName.value,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                min: "0",
                class: "form-control height-43",
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((keyreleasetoaddressLine1).value = $event)),
                autocomplete: "keyreleasetoaddressLine1"
              }, null, 512), [
                [
                  _vModelText,
                  keyreleasetoaddressLine1.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                min: "0",
                class: "form-control height-43",
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((keyreleasetoaddressLine2).value = $event)),
                autocomplete: "keyreleasetoaddressLine2"
              }, null, 512), [
                [
                  _vModelText,
                  keyreleasetoaddressLine2.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            min: "0",
            class: "form-control height-43",
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((keyreleasetoaddressTown).value = $event)),
            autocomplete: "keyreleasetoaddressTown"
          }, null, 512), [
            [
              _vModelText,
              keyreleasetoaddressTown.value,
              void 0,
              { lazy: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            min: "0",
            class: "form-control height-43",
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((keyreleasetoaddressPostcode).value = $event)),
            autocomplete: "keyreleasetoaddressPostcode"
          }, null, 512), [
            [
              _vModelText,
              keyreleasetoaddressPostcode.value,
              void 0,
              { lazy: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            min: "0",
            class: "form-control height-43",
            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((keyreleasetoaddressPhone).value = $event)),
            autocomplete: "keyreleasetoaddressPhone"
          }, null, 512), [
            [
              _vModelText,
              keyreleasetoaddressPhone.value,
              void 0,
              { lazy: true }
            ]
          ])
        ]),
        _hoisted_46
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tenantsarray.value, (tenant, $index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["row", { 'mt-1': $index > 0 }]),
              key: $index
            }, [
              _createElementVNode("div", {
                class: _normalizeClass({ 'col-md-4':isNewBooking(), 'col-md-3':  !isNewBooking()})
              }, [
                ($index === 0)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_49, "Tenant Name "))
                  : _createCommentVNode("", true),
                (booking.value?.previousbooking?.jobtype === 'checkout' && booking.value?.jobtype === 'checkin' && booking.value.previousbooking.tenantNameList.length > 0)
                  ? (_openBlock(), _createBlock(_component_Popper, {
                      key: 1,
                      class: "light-popper float-right pt-2",
                      placement: "top",
                      hover: "true",
                      arrow: "true"
                    }, {
                      content: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.value.previousbooking.tenants, (tenant, $index) => {
                          return (_openBlock(), _createElementBlock("div", { key: $index }, _toDisplayString(tenant.ttname), 1))
                        }), 128))
                      ]),
                      default: _withCtx(() => [
                        _hoisted_50
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  min: "0",
                  class: _normalizeClass(["form-control height-43", { 'text-danger': tenant.attending === 'no', 'text-success': tenant.attending === 'yes' }]),
                  "onUpdate:modelValue": ($event: any) => ((tenant.ttname) = $event),
                  onChange: _cache[26] || (_cache[26] = ($event: any) => (addUnsavedChange('ttname')))
                }, null, 42, _hoisted_51), [
                  [
                    _vModelText,
                    tenant.ttname,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass({ 'col-md-4':isNewBooking(), 'col-md-3':  !isNewBooking()})
              }, [
                ($index === 0)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_52, "Tenant Email"))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  min: "0",
                  class: _normalizeClass(["form-control height-43", { 'text-danger': tenant.attending === 'no', 'text-success': tenant.attending === 'yes' }]),
                  "onUpdate:modelValue": ($event: any) => ((tenant.ttemail) = $event),
                  onChange: _cache[27] || (_cache[27] = ($event: any) => (addUnsavedChange('ttemail'))),
                  autocomplete: "ttemail"
                }, null, 42, _hoisted_53), [
                  [
                    _vModelText,
                    tenant.ttemail,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ], 2),
              _createElementVNode("div", _hoisted_54, [
                ($index === 0)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_55, "Tenant Mobile"))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_56, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    min: "0",
                    class: _normalizeClass(["form-control height-43", { 'text-danger': tenant.attending === 'no', 'text-success': tenant.attending === 'yes' }]),
                    "onUpdate:modelValue": ($event: any) => ((tenant.ttmobile) = $event),
                    onChange: _cache[28] || (_cache[28] = ($event: any) => (addUnsavedChange('ttmobile'))),
                    autocomplete: "ttmobile"
                  }, null, 42, _hoisted_57), [
                    [
                      _vModelText,
                      tenant.ttmobile,
                      void 0,
                      { lazy: true }
                    ]
                  ]),
                  (tenant.ttmobile && isInternationalNumber(tenant.ttmobile))
                    ? (_openBlock(), _createElementBlock("i", _hoisted_58))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                ($index > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-sm btn-outline-secondary",
                      onClick: _withModifiers(($event: any) => (removeTenant(tenant)), ["prevent"])
                    }, _hoisted_62, 8, _hoisted_60))
                  : _createCommentVNode("", true)
              ]),
              (!isNewBookingOrTenantBlank(tenant))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["col-md-2", {'mt-5' : $index === 0,'mt-2' : $index !== 0}])
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass({ 'far fa-circle fa-1x red': tenant.attending !== 'no', 'far fa-dot-circle fa-1x red': tenant.attending === 'no' }),
                      onClick: ($event: any) => (tenansFlag('red',tenant,$index))
                    }, null, 10, _hoisted_63),
                    _createElementVNode("i", {
                      class: _normalizeClass({ 'far fa-circle fa-1x amber': tenant.attending !== 'unsure' || tenant.attending !== '', 'far fa-dot-circle fa-1x amber': tenant.attending === 'unsure' || tenant.attending === '' }),
                      onClick: ($event: any) => (tenansFlag('amber',tenant,$index))
                    }, null, 10, _hoisted_64),
                    _createElementVNode("i", {
                      class: _normalizeClass({ 'far fa-circle fa-1x green': tenant.attending !== 'yes', 'far fa-dot-circle fa-1x green': tenant.attending === 'yes' }),
                      onClick: ($event: any) => (tenansFlag('green',tenant,$index))
                    }, null, 10, _hoisted_65)
                  ], 2))
                : _createCommentVNode("", true)
            ], 2))
          }), 128)),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-secondary mt-2",
                onClick: _withModifiers(addTenant, ["prevent"])
              }, [
                _hoisted_68,
                _createTextVNode(" Add ")
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_69, [
          _hoisted_70,
          _withDirectives(_createElementVNode("textarea", {
            class: "form-control",
            ref_key: "accessissuesref",
            ref: accessissuesref,
            rows: "8",
            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((accessissues).value = $event))
          }, null, 512), [
            [
              _vModelText,
              accessissues.value,
              void 0,
              { lazy: true }
            ]
          ]),
          _createElementVNode("i", {
            class: "fas fa-arrow-down text-right ml-2",
            onClick: showAccessIssuesnotesModal,
            style: _normalizeStyle({ background: accessissuesrowCount.value ? 'yellow !important' : '' })
          }, null, 4)
        ]),
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _hoisted_75,
                _createElementVNode("div", null, [
                  _createVNode(TriStateToggle, {
                    value: tenantattending.value,
                    onSelect: setTenantattending
                  }, null, 8, ["value"])
                ])
              ])
            ]),
            (jobtype.value === 'inventory' || jobtype.value === 'checkin')
              ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                  _hoisted_77,
                  _createVNode(_component_singleselect_text, {
                    modelValue: keystobereleased.value,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((keystobereleased).value = $event)),
                    options: releasekeysOptions
                  }, _createSlots({ _: 2 }, [
                    (keystobereleased.value)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              onMousedown: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (keystobereleased.value = ''), ["prevent","stop"])),
                              class: "multiselect__clear fa fa-times",
                              "aria-label": "Clear"
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("div", _hoisted_80, [
                _hoisted_81,
                _createElementVNode("div", null, [
                  _createVNode(_unref(DxSwitch), {
                    value: donotcontacttt.value,
                    onValueChanged: _cache[32] || (_cache[32] = ($event: any) => (donotcontacttt.value = $event.value))
                  }, null, 8, ["value"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("span", null, [
                _hoisted_83,
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("div", _hoisted_85, [
                    (_openBlock(), _createBlock(Documents, {
                      buttontext: 'Upload',
                      entity: 'booking',
                      key: booking.value.accessattachments.length,
                      documents: booking.value.accessattachments,
                      path: 'accessattachments',
                      onClicked: showAccessattachementDocument
                    }, null, 8, ["documents"]))
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    (!accessnotePresent())
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: _normalizeClass(["btn btn-sm btn-outline-secondary mt-2", { 'yellow-outline': accessnotePresent() }]),
                          onClick: _withModifiers(showAccessnotesModal, ["prevent"])
                        }, " Text content ", 2))
                      : (_openBlock(), _createElementBlock("i", {
                          key: 1,
                          class: "far fa-4x fa-file-alt mt-2",
                          onClick: _withModifiers(showAccessnotesModal, ["prevent"])
                        }))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(AccessnotesDialog, {
      name: `accessnotes-modal`,
      ref_key: "accessnotesModal",
      ref: accessnotesModal,
      booking: booking.value
    }, null, 8, ["booking"]),
    _createVNode(AccessIssueNotesDialog, {
      title: "Access notes seen by PI",
      name: `accessissuesnotes-modal`,
      ref_key: "accessissuesnotesModal",
      ref: accessissuesnotesModal
    }, null, 512)
  ]))
}
}

})